import { render, staticRenderFns } from "./SearchController.vue?vue&type=template&id=a52cbd58&"
import script from "./SearchController.vue?vue&type=script&lang=js&"
export * from "./SearchController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports